// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
import SchoolDetailsEditor from 'components/schools/SchoolDetailsEditor';

class SchoolEditorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      queue: {},
      fetching: false,

      error: '',
      school: [],
      parentSchool: [],
      cache: {
        locationsByType: {
          region: [],
          province: [],
          city: []
        }
      },
    };

    this.fetchSchool = this.fetchSchool.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.fetchSchool();
  }

  componentWillUnmount() {
    console.log('Will unmount');

    // abort all Ajax calls
    Object.keys(this.state.queue).forEach((key) => {
      console.log('got controller');

      const controller = this.state.queue[key];
      if (controller) {
        XHR.abort(controller);
      }
    });
  }

  fetchSchool() {
    const SCHOOL_ID = this.props.match.params.schoolId;
    if (!SCHOOL_ID) {
      this.setState({
        error: 'School ID missing'
      });

      return false;
    }

    this.setState((prevState) => {
      prevState.school = null;

      return prevState;
    });

    let oldController = this.state.queue['school'];
    if (oldController) {
      XHR.abort(oldController);
    }

    let endpoint = Settings.V3_API_URL + '/schools';
    let controller = XHR.fetch('GET', endpoint, {
      q: SCHOOL_ID,
      offset: 0,
      limit: -1,
      t: (new Date()).getTime()
    }, {}, (response, error) => {
      if (error) {
        this.setState((prevState) => {
          delete prevState.queue['school'];

          prevState.error = error.message + ' while getting school';

          return prevState;
        });

        return false;
      }

      if (!response.data.schools) {
        alert('Cannot get school! (no schools in response)');

        console.error('cannot get schools');
        console.dir(response);

        return false;
      }

      const school = response.data.schools[0];
      this.setState((prevState) => {
        delete prevState.queue['school'];
        prevState.school = school;

        return prevState;
      });

      // get school data
      let oldController = this.state.queue['school_data'];
      if (oldController) {
        XHR.abort(oldController);
      }

      let endpoint = Settings.V3_API_URL + '/school_data/' + this.state.school.id;
      let controller = XHR.fetch('GET', endpoint, {
        t: (new Date()).getTime()
      }, {}, (response, error) => {
        if (error) {
          this.setState((prevState) => {
            delete prevState.queue['school_data'];

            prevState.error = error.message + ' while getting school data';

            return prevState;
          });

          return false;
        }

        const schoolData = response.data.school_data; // could be null, it's fine.

        const updatedSchool = Object.assign(this.state.school, schoolData);
        this.setState((prevState) => {
          delete prevState.queue['school_data'];
          prevState.school = updatedSchool;

          return prevState;
        });
      });

      this.setState((prevState) => {
        prevState.queue['school_data'] = controller;

        return prevState;
      });
    });

    this.setState((prevState) => {
      prevState.queue['school'] = controller;

      return prevState;
    });
  }

  handleSubmit() {
    const endpoint = Settings.V3_API_URL + '/school_data/' + this.state.school.id;
    const payload = Object.assign(this.state.school, {
      school_id: this.state.school.id
    });
    // const options = {
    //   headers: {
    //     Authorization: Auth.getToken() ? ('Bearer ' + Auth.getToken()) : ''
    //   }
    // }
    API.call('PUT', endpoint, payload, (response, error) => {
      if (error) {
        alert('ERRORE API!');

        return false;
      }

      if (!response.ok) {
        alert('Cannot save school!');

        console.error('cannot get schools');
        console.dir(response);

        return false;
      }

      this.fetchSchool();
    });
  }

  render() {
    const fetching = Object.keys(this.state.queue).length || this.state.school == false;

    const content = (
      <SchoolDetailsEditor school={this.state.school} onSubmit={this.handleSubmit} />
    );

    return (
      <div>
        <PageHeader>
          <ButtonsToolbar
            back={
              this.state.school ? ({
                label: 'torna alla scuola',
                href: `/schools/${this.state.school.id}/view/`
              }) : null
            }
          />
          <MainHeading
            icon={this.state.school && !this.state.school.parent_school ? 'fa fa-university' : 'fa fa-school'}
            title={this.state.school ? this.state.school.name : ''}
            descr={this.state.school ? (
              <span style={{fontSize: '150%', color: '#888'}}>{this.state.school.type}</span>
            ) : ''}
          />
        </PageHeader>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: '',
            descr: ''
          }}
          filters={{
            tabs: []
          }}
          search={null}
          status={{
            fetching: fetching,
            errors: null
          }}
        >
          {content}
        </PageDataWrapper>
      </div>
    );
  }
}

export default SchoolEditorPage;


// WEBPACK FOOTER //
// ./src/pages/schools/SchoolEditorPage.js